import moment from 'moment';

export default {
  methods: {
    formatDate(date, customNullDate) {
      if (date) {
        return moment(date)
          .local()
          .format('MM-DD-YYYY h:mmA');
      } if (customNullDate) {
        return customNullDate;
      }
      return '';
    },
  },
};
